import React from "react";
import { Typography, Button, Layout, Row, Card, Col } from "antd";
import Migas from "../../../config/Migas";
import { ReactComponent as ImgEnvio } from "../../../assets/img/Correo/CorreoEnviadoContraseña.svg";
const { Paragraph, Text } = Typography;

export const FormExito = () => {
  const [clickinicio] = Migas();
  const correo = localStorage.getItem("correo");

  return (
    <Layout className="body-style">
      <Row align="center" className="top-row-form">
        <Col span={6} xxl={6} xl={8} lg={12} md={24} sm={24} xs={24}>
          <Card className="card-form">
            <div>
              <ImgEnvio className="form-img" />
              <br />
              <Typography>
                <Paragraph>
                  <Text className="text-inicio-form">
                    Se ha enviado a tu correo electrónico {correo} una nueva
                    contraseña
                  </Text>
                  {""}
                  <Text
                    style={{
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#333333",
                    }}
                  >
                    , la anterior no podrás usarla.
                  </Text>
                </Paragraph>
                <br />
                <ul>
                  <li>
                    <p className="txt-form">
                      Revisa tener el espacio suficiente en tu cuenta de correo
                      electrónico para recibir notificaciones.
                    </p>
                  </li>
                </ul>
                <ul>
                  <li className="li-form">
                    <p className="txt-form">
                      Verifica la bandeja de entrada y correo no deseado.
                    </p>
                  </li>
                </ul>
              </Typography>
            </div>
            <center>
              <div>
                <Button
                  onClick={() => clickinicio()}
                  type="primary"
                  htmlType="submit"
                  className="btn-form"
                  size="large"
                >
                  Continuar
                </Button>
              </div>
            </center>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};
